import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useMemo, useState } from "react";

type PlayerContextType = {
  onVideoPlay?: () => any;
  onSpeechStart?: () => any;
  setOnVideoPlay: Dispatch<SetStateAction<any>>;
  setOnSpeechStart: Dispatch<SetStateAction<any>>;
};

export const PlayerContext = createContext<PlayerContextType>({
  setOnSpeechStart: () => {},
  setOnVideoPlay: () => {},
});

const PlayerContextComp: FC<PropsWithChildren> = ({ children }) => {
  const [onSpeechStart, setOnSpeechStart] = useState<() => any>();
  const [onVideoPlay, setOnVideoPlay] = useState<() => any>();
  // const onSpeechStartRef = useRef<() => any>(() => {});
  // const onVideoPlayRef = useRef<() => any>(() => {});

  // const setOnSpeechStart = useCallback((fn: () => any) => (onSpeechStartRef.current = fn), []);
  // const setOnVideoPlay = useCallback((fn: () => any) => (onVideoPlayRef.current = fn), []);

  const value = useMemo(() => ({ setOnVideoPlay, setOnSpeechStart, onSpeechStart, onVideoPlay }), [onSpeechStart, onVideoPlay]);

  return <PlayerContext.Provider value={value}>{children}</PlayerContext.Provider>;
};

export default PlayerContextComp;
